import { render, staticRenderFns } from "./StudentRestore.vue?vue&type=template&id=ce3610f2"
import script from "@/controllers/custom/student/student-restore.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/student/student-restore.js?vue&type=script&lang=js&external"
import style0 from "./StudentRestore.vue?vue&type=style&index=0&id=ce3610f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports